function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 0.16,
  y1: 0.16,
  x2: 0.849,
  y2: 0.849,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#e6e6e6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 0.852,
  y1: 0.852,
  x2: 0.091,
  y2: 0.091,
  xlinkHref: "#a"
}));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 135.697,
  cy: 135.697,
  r: 135.697,
  transform: "translate(814.568 2467.67) rotate(-4.183)",
  opacity: 0
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 135.695,
  cy: 135.695,
  r: 135.695,
  transform: "translate(816.651 2719.812) rotate(-86.758)",
  opacity: 0.083
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 135.697,
  cy: 135.697,
  r: 135.697,
  transform: "matrix(0.998, -0.067, 0.067, 0.998, 815.354, 2464.565)",
  opacity: 0.167
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 135.697,
  cy: 135.697,
  r: 135.697,
  transform: "translate(814.568 2464.368) rotate(-4.183)",
  opacity: 0.25
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 135.695,
  cy: 135.695,
  r: 135.695,
  transform: "translate(816.651 2716.509) rotate(-86.758)",
  opacity: 0.333
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 135.695,
  cy: 135.695,
  r: 135.695,
  transform: "translate(816.651 2715.409) rotate(-86.758)",
  opacity: 0.417
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 135.695,
  cy: 135.695,
  r: 135.695,
  transform: "translate(816.651 2714.308) rotate(-86.758)",
  opacity: 0.5
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 135.695,
  cy: 135.695,
  r: 135.695,
  transform: "translate(816.651 2714.308) rotate(-86.758)",
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M1081.088,2586.5A121.288,121.288,0,1,1,959.8,2465.218,121.287,121.287,0,0,1,1081.088,2586.5Z",
  fill: "#f4c478"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 108.936,
  cy: 108.936,
  r: 108.936,
  transform: "translate(842.811 2686.74) rotate(-85.59)",
  fill: "url(#a)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M1063.527,2586.5A103.724,103.724,0,1,1,959.8,2482.78,103.724,103.724,0,0,1,1063.527,2586.5Z",
  fill: "url(#b)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M1010.942,2625.969H995.06a.973.973,0,0,1-.97-.974v-80.608a.971.971,0,0,1,.97-.971h15.882a.973.973,0,0,1,.975.971V2625A.975.975,0,0,1,1010.942,2625.969Zm-14.907-1.949h13.933v-78.658H996.035Z",
  fill: "#f4c478"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M989.769,2625.969H973.885a.977.977,0,0,1-.975-.974v-70.613a.975.975,0,0,1,.975-.972h15.884a.971.971,0,0,1,.972.972V2625A.973.973,0,0,1,989.769,2625.969Zm-14.912-1.949h13.937v-68.664H974.857Z",
  fill: "#f4c478"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M968.589,2625.969H952.707a.975.975,0,0,1-.975-.974v-60.9a.972.972,0,0,1,.975-.972h15.882a.971.971,0,0,1,.974.972V2625A.975.975,0,0,1,968.589,2625.969Zm-14.91-1.949h13.938v-58.952H953.679Z",
  fill: "#f4c478"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M947.413,2625.969H931.527a.975.975,0,0,1-.973-.974v-47.367a.973.973,0,0,1,.973-.972h15.886a.974.974,0,0,1,.973.972V2625A.976.976,0,0,1,947.413,2625.969Zm-14.91-1.949h13.936V2578.6H932.5Z",
  fill: "#f4c478"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M926.234,2625.969H910.349a.973.973,0,0,1-.972-.974v-33.252a.972.972,0,0,1,.972-.975h15.885a.975.975,0,0,1,.973.975V2625A.976.976,0,0,1,926.234,2625.969Zm-14.912-1.949H925.26v-31.306H911.322Z",
  fill: "#f4c478"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M1018.889,2630.964H902.409a.973.973,0,1,1,0-1.946h116.48a.973.973,0,0,1,0,1.946Z",
  fill: "#f4c478"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M907.107,2579.934a.974.974,0,0,1-.329-1.889c.52-.189,52.389-19.055,75.187-45.613a.972.972,0,1,1,1.474,1.267c-23.128,26.949-75.477,45.989-76,46.177A.96.96,0,0,1,907.107,2579.934Z",
  fill: "#f4c478"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M982.434,2545.841h0a.976.976,0,0,1-.972-.975l.012-10.512-9.933.044h0a.973.973,0,0,1-.007-1.946l10.912-.05a.982.982,0,0,1,.692.286.971.971,0,0,1,.286.688l-.012,11.49A.975.975,0,0,1,982.434,2545.841Z",
  fill: "#f4c478"
});

var SvgPartner6 = function SvgPartner6(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290.467,
    height: 294.988,
    viewBox: "0 0 290.467 294.988",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-814.568 -2443.353)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9), _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPartner6, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/partner6.492f7295.svg";
export { ForwardRef as ReactComponent };